import { Toaster } from "components";

import { apiDisability, companyOverviewConstants } from '../constants';

import { promiseInstance_authorization } from './config';

import { func_validation, func_serviceHandling, isObjectNotEmpty, isNumberValid, isStringTrimNotEmpty, isNotNullUndefined, getObjectPropertyValue } from 'functions';



export const companyOverviewActions = {
	getOutletList,
	getLicenseList,
	getPackageList,

	addOutlet,
	addLicense,
	resetLicense,
	deleteLicense,
	updateLicenseRemark,
	changeCompanyStatus,
	suspendCOM,
};

function getOutletList(comID, pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;
		let sort_validated = isStringTrimNotEmpty(sort)? sort:"";
		let comID_validated = isNotNullUndefined(comID)? comID:"";

		let createdDate = getObjectPropertyValue(filterOptions, "createdDate");
		let sortByOrderLatest = getObjectPropertyValue(filterOptions, "sortByOrderLatest", true);

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort_validated,
			createdDate: createdDate,
			sortByOrderLatest: sortByOrderLatest,
		}

		let url = func_serviceHandling.createUrlWithParams('/ComInfo/GetOutlets/' + comID_validated, paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
					
					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load outlet list";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.getOutletList_request, details }; }
    function success(details) { return { type: companyOverviewConstants.getOutletList_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.getOutletList_failure, error }; }
}

function getLicenseList(comID, pageNo, pageSize, sort, filterOptions) {
    return dispatch => {
		dispatch(request());

		let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;
		let sort_validated = isStringTrimNotEmpty(sort)? sort:"";
		let comID_validated = isNotNullUndefined(comID)? comID:"";

		let createdDate = getObjectPropertyValue(filterOptions, "createdDate");
		let licenseKey = getObjectPropertyValue(filterOptions, "licenseKey");
		let deviceName = getObjectPropertyValue(filterOptions, "deviceName");
		let packageid = getObjectPropertyValue(filterOptions, "packageid");

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort_validated,
			createdDate: createdDate,
			licenseKey: licenseKey,
			deviceName: deviceName,
			packageid: packageid,
		}

		let url = func_serviceHandling.createUrlWithParams('/ComInfo/GetComLicense/' + comID_validated, paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load license list";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.getLicenseList_request, details }; }
    function success(details) { return { type: companyOverviewConstants.getLicenseList_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.getLicenseList_failure, error }; }
}

function getPackageList() {
    return dispatch => {
		dispatch(request());

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get('/ComInfo/GetPackageList')
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load package list";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.getPackageList_request, details }; }
    function success(details) { return { type: companyOverviewConstants.getPackageList_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.getPackageList_failure, error }; }
}

function addOutlet(outletInfo) {
    return dispatch => {
		dispatch(request());
		
		let outletInfo_validated = {};
		if (isObjectNotEmpty(outletInfo)) outletInfo_validated = outletInfo;

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(apiDisability + '/ComInfo/AddOutlet', JSON.stringify(outletInfo_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully add outlet"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add outlet";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.addOutlet_request, details }; }
    function success(details) { return { type: companyOverviewConstants.addOutlet_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.addOutlet_failure, error }; }
}

function addLicense(licenseInfo) {
    return dispatch => {
		dispatch(request());
		
		let licenseInfo_validated = {};
		if (isObjectNotEmpty(licenseInfo)) licenseInfo_validated = licenseInfo;

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(apiDisability + '/ComInfo/AddLicense', JSON.stringify(licenseInfo_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully add license"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add license";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.addLicense_request, details }; }
    function success(details) { return { type: companyOverviewConstants.addLicense_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.addLicense_failure, error }; }
}

function resetLicense(licenseInfo) {
    return dispatch => {
		dispatch(request());
		
		let licenseInfo_validated = {};
		if (isObjectNotEmpty(licenseInfo)) licenseInfo_validated = licenseInfo;

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(apiDisability + '/ComInfo/ResetLicense', JSON.stringify(licenseInfo_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully reset license"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to reset license";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.resetLicense_request, details }; }
    function success(details) { return { type: companyOverviewConstants.resetLicense_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.resetLicense_failure, error }; }
}

function deleteLicense(licenseInfo) {
    return dispatch => {
		dispatch(request());
		
		let licenseInfo_validated = {};
		if (isObjectNotEmpty(licenseInfo)) licenseInfo_validated = licenseInfo;

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete(apiDisability + '/ComInfo/DeleteLicense', { data: JSON.stringify(licenseInfo_validated)})
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deleted license"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete license";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.deleteLicense_request, details }; }
    function success(details) { return { type: companyOverviewConstants.deleteLicense_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.deleteLicense_failure, error }; }
}

function updateLicenseRemark(id, licenseInfo) {
    return dispatch => {
		dispatch(request());

		let id_formatted = "";
    	if (isNumberValid(id)) id_formatted = id;
		
		let licenseInfo_validated = {};
		if (isObjectNotEmpty(licenseInfo)) licenseInfo_validated = licenseInfo;

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(apiDisability + '/ComInfo/UpdateLicenseRemark/' + id_formatted, JSON.stringify(licenseInfo_validated))
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully updated license remark"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update license remark";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.updateLicenseRemark_request, details }; }
    function success(details) { return { type: companyOverviewConstants.updateLicenseRemark_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.updateLicenseRemark_failure, error }; }
}

function changeCompanyStatus(comID, status) {
    return dispatch => {
		dispatch(request());
		
		let comID_formatted = "";
		if (isNumberValid(comID)) comID_formatted = comID;
		let status_formatted = "";
		if (isStringTrimNotEmpty(status)) status_formatted = status;

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.put(apiDisability + '/ComInfo/ChangeComStatus/' + comID_formatted + '/' + status_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully changed company status"});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to change company status";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.changeCompanyStatus_request, details }; }
    function success(details) { return { type: companyOverviewConstants.changeCompanyStatus_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.changeCompanyStatus_failure, error }; }
}

function suspendCOM(comID) {
    return dispatch => {
		dispatch(request());
		
		let comID_formatted = "";
		if (isNumberValid(comID)) comID_formatted = comID;

        promiseInstance_authorization(dispatch, request, (axios) => {
			axios.put(apiDisability + '/ComInfo/SuspendCom/' + comID_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully suspended COM " + comID_formatted});
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to suspend COM " + comID_formatted;
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
    }

    function request(details) { return { type: companyOverviewConstants.suspendCOM_request, details }; }
    function success(details) { return { type: companyOverviewConstants.suspendCOM_success, details }; }
    function failure(error) { return { type: companyOverviewConstants.suspendCOM_failure, error }; }
}